document.addEventListener('DOMContentLoaded', function() {
  const modal = document.getElementById('imageModal');
  const modalImg = document.getElementById('modalImage');
  const closeBtn = document.querySelector('.image-modal-close');
  const galleryImages = document.querySelectorAll('.product-image-gallery-image');

  // Open modal when clicking on gallery images
  galleryImages.forEach(function(imageContainer) {
    imageContainer.addEventListener('click', function() {
      const imageSrc = this.getAttribute('data-modal-image');
      modalImg.src = imageSrc;
      modalImg.alt = this.querySelector('img').alt;
      modal.classList.add('active');
      document.body.style.overflow = 'hidden'; // Prevent background scrolling
    });
  });

  // Close modal when clicking the close button
  closeBtn.addEventListener('click', function() {
    modal.classList.remove('active');
    document.body.style.overflow = 'auto'; // Restore scrolling
  });

  // Close modal when clicking outside the image
  modal.addEventListener('click', function(e) {
    if (e.target === modal) {
      modal.classList.remove('active');
      document.body.style.overflow = 'auto'; // Restore scrolling
    }
  });

  // Close modal with Escape key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && modal.classList.contains('active')) {
      modal.classList.remove('active');
      document.body.style.overflow = 'auto'; // Restore scrolling
    }
  });
});
